import {gql, useQuery} from "@apollo/client";
import {Box, Spinner} from "@chakra-ui/react";
import SentimentBarGrid from "./SentimentBarGrid";
import {useState} from "react"

export const countsGroupBySentimentquery = gql`
query SentimentCounts($product_ids: [String!] = "", $start_date: date, $end_date: date) {
  counts_group_by_sentiment(where: {product_platform_id: {_in: $product_ids}}, args: {end_date: $end_date, start_date: $start_date}) {
    aspect
    count
    product_platform_id
    sentiment
  }
}
`
export const countsGroupBySentimentFilterByAspectsQuery = gql`
query SentimentCounts($product_ids: [String!] = "", $start_date: date, $end_date: date, $aspects: [String!] = "") {
  counts_group_by_sentiment(where: {product_platform_id: {_in: $product_ids}, aspect: {_in: $aspects}}, args: {end_date: $end_date, start_date: $start_date}) {
    aspect
    count
    product_platform_id
    sentiment
  }
}
`


export default function SentimentFetcher(props) {
    const {product_ids, handleClickFn, aspects, selectedAspect, startDate, endDate} = props;
    const [expanded, setExpanded] = useState(false);

    function onExpandAspects() {
        setExpanded(prevState => !prevState);
    }

    let {loading, error, data} = useQuery(countsGroupBySentimentquery,
        {
            variables: {"product_ids": product_ids, "start_date": startDate, "end_date": endDate},
            skip: typeof aspects !== 'undefined'
        },
    );
    let {loading: loadingA, error: errorA, data: dataA} = useQuery(countsGroupBySentimentFilterByAspectsQuery,
        {
            variables: {"product_ids": product_ids, "aspects": aspects, "start_date": startDate, "end_date": endDate},
            skip: typeof aspects === 'undefined'
        },
    );
    if (typeof aspects === 'undefined') {
        if (loading) return <Box pt={{base: "130px", md: "80px", xl: "80px"}}><Spinner/></Box>;
        if (error) return `Error! ${error.message}`;
    } else {
        if (loadingA) return <Box pt={{base: "130px", md: "80px", xl: "80px"}}><Spinner/></Box>;
        if (errorA) return `Error! ${errorA.message}`;
        data = dataA;
    }
    //console.log("data ", data);
    let chart_data = {};

    for (let obj of data.counts_group_by_sentiment) {
        let asp = obj["aspect"];
        if (!chart_data.hasOwnProperty(asp)) {
            chart_data[asp] = {"positive": 0, "negative": 0, "neutral": 0};
        }
        chart_data[asp][obj["sentiment"]] += obj["count"];
    }
    let sortable = [];
    for (var [aspect, val] of Object.entries(chart_data)) {
        sortable.push({"aspect": aspect, ...val});
    }
    sortable.sort(function (a, b) {
        return (b["positive"] + b["neutral"] + b["negative"]) - (a["positive"] + a["negative"] + a["neutral"]);
    })

    let chart_series = []
    let chart_categories = [];

    for (let val of sortable) {

        chart_series.push([{name: "Positive", data: [val["positive"]]}, {
            name: "Neutral",
            data: [val["neutral"]]
        }, {name: "Negative", data: [val["negative"]]}])//
        chart_categories.push(val["aspect"]);
    }
    console.log("chart_series", chart_series);
    console.log("categories", chart_categories);

    return (
        <SentimentBarGrid series={chart_series} categories={chart_categories} handleClick={handleClickFn}
                          expandAspects={expanded} onExpandAspects={onExpandAspects} selectedAspect={selectedAspect}/>
    )
}